import React, { FC } from 'react';

const IconAsterRojo: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="112"
      viewBox="0 0 15 112"
      {...props}
    >
      <g fill="none" fillRule="evenodd" transform="translate(0 1)">
        <line
          x1="8"
          x2="7.5"
          y2="89.841"
          stroke="#4A4B4D"
          strokeDasharray="0 4.03"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <polygon
          fill="#E1001A"
          points="5.391 96 6.718 102 2.031 97.974 0 101.684 5.625 103.421 0 105.316 2.188 109.184 6.641 104.922 5.391 111 9.609 111 8.281 105 12.812 109.184 15 105.316 9.375 103.5 15 101.684 12.969 97.974 8.359 102.039 9.609 96"
        />
      </g>
    </svg>
  );
};

export default IconAsterRojo;
